import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import $ from 'jquery';
import Add_ticket from './../../assets/images/add.png';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import { userList } from "../../actions/organizationChart";
import { connect } from "react-redux";
import * as actionFunction from "../../actions/common";
class OrgchartByPeople extends Component {
    constructor() {
        super();
        this.state = {
            targetelemnt: ''
        };

    }
    get_child_members(id, count, parent_id, event) {
        var commonStateData = actionFunction.commonData()
        let dynamic = document.getElementById('dynamicid').value;
        this.targetelemnt = $(event.target).parents('.childhood');
        this.targetelemnt.nextAll('.childhood').remove();
        if (dynamic != 1) {
            return false;
        }
        document.getElementById("dynamicid").value = 2;
        this.targetelemnt.after('<div class="loader-new" id="loader-new"></div>')
        fetch(commonStateData.apiUrl + '/HrmanagementRest/printTree1/id/' + id + '/userAuthKey/' + commonStateData.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
                .then((Response) => Response.json())
                .then((findresponse, event) => {
                    findresponse = actionFunction.decrypt(findresponse, 1);
                    if (findresponse.organisation_member.length > 0) {
                        var rest = this.getChildEmpList(findresponse);
                        this.targetelemnt.after(rest);
                    }
                    $("#loader-new").remove();
                    document.getElementById("dynamicid").value = 1;
                })
    }

    getChildEmpList(res) {
        var tml = '<div class="childhood dynamic">';
        for (var i = 0; i < res.organisation_member.length; i++) {
            var info = res.organisation_member[i];
            var count = info.count > 0 ? info.count : '';
            var image = info.attachment ? '<img src=' + info.attachment_url + info.attachment + ' />' : '<span class="profile_first_name">' + info.name.charAt(0).toUpperCase() + '</span>';
            tml += '<div class="org_box tooltips" data-id="' + info.id + '"  data-name="' + info.name + '"><div class="tooltiptext"><div class="tip_name">' + info.name + '</div><div class="tip_position">' + info.position + '</div></div><div class="er_moniter">';
            tml += '<div class="text-inded" data-id="' + info.id + '"><a href="javascript:void(0)">' + info.name + '</a></div><div class="position text-inded" data-id="' + info.id + '">' + info.position + '</div>';
            tml += '<div class="pro_image pull-left">' + image + '</div>';
            tml += '<span class="member" data-id="' + info.id + '"  data-name="' + info.name + '">' + count + '</span>';
            tml += '</div></div>';
        }
        tml += '</div>';
        return tml;
    }

    componentDidMount() {
        document.title = "Intranet | OrganizationChart";
        if (!localStorage.getItem('userLogin')) {
            this.setState({redirect: true});
        }
        this.props.userList();
        $('.searchTicket.dept').on('click', function () {
            $(this).closest('.intranet_body').find('.filter_dept').slideToggle('slow');
        });
        var _ = this;
        $(document).on("click", ".text-inded", function (e) {
            let dataId = $(this).data('id');
            window.location.href = '/viewEmployee/' + dataId;
            return false;
        });
        $(document).on("click", ".org_box", function (e) {
            $(this).parents(".childhood").find(".org_box").removeClass('active')
            $(this).addClass('active');
            let dataId = $(this).data('id');
            let name = $(this).data('name');
            _.get_child_members(dataId, 1, 2, e)

        });
    }
    render() {
        if (this.state.redirect) {
            return (
                    <Redirect to={'/login'} />
                    )
        }
        return (
                <div>
                    {this.getUserRows()}
                </div>
                );
    }
    getUserRows() {
        if (this.props.loading) {
            return (
                    <div class="loader-new"></div>
                    )
        } else {
            return (
                    <div class="list_check">
                        <div className="parent_box">
                            <div class="org_box active tooltips">
                                <div class="tooltiptext"><div class="tip_name">{this.props.users_md.md_name}</div><div class="tip_position">{this.props.users_md.md_position}</div></div>
                                <div class="er_moniter">
                                    <div class="text-inded" data-id={this.props.users_md.md_id}><a href="javascript:void(0)"> {this.props.users_md.md_name}</a></div>
                                    <div class="position text-inded" data-id={this.props.users_md.md_id}>{this.props.users_md.md_position}</div>
                                    <input type="hidden" name="dynamicid" id="dynamicid" value="1"/>
                                    <div class="pro_image pull-left text-inded" data-id={this.props.users_md.md_id}>
                                        {this.props.users_md.md_attactment ? <img src={this.props.users_md.md_attachment_url + this.props.users_md.md_attactment} /> : <span class="profile_first_name">{this.props.md_name_cond}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="childhood" id="childhood">
                            {
                                this.props.organisation.map((user, key) =>
                                        <div class="org_box tooltips" data-id={user.id}>
                                            <div class="tooltiptext"><div class="tip_name">{user.name}</div><div class="tip_position">{user.position}</div></div>
                                            <div class="er_moniter">
                                                <div class="text-inded" data-id={user.id}><a href="javascript:void(0)"> {user.name}</a></div>
                                                <div class="position text-inded" data-id={user.id}>{user.position}</div>
                                                <div class="pro_image pull-left text-inded" data-id={user.id}>
                                                    {user.attachment ? <img src={user.attachment_url + user.attachment} /> : <span class="profile_first_name">{user.name.charAt(0).toUpperCase()}</span>}
                                                </div>
                                                <span class="member">{user.count > 0 ? user.count : ''}</span>
                                            </div>
                                        </div>

                                )}
                        </div>
                    </div>

                    )
        }
    }
}
const mapStateToProps = (state) => {
    return {
        organisation: state.mOrgRe.organisation,
        users_md: state.mOrgRe.users_md,
        md_name_cond: state.mOrgRe.md_name_cond,
        loading: state.mOrgRe.loading,
    }

}
const mapDispatchToProps = {
    userList
}
export default connect(mapStateToProps, mapDispatchToProps)(OrgchartByPeople);



// WEBPACK FOOTER //
// ./src/components/hrAdmin/OrgchartByPeople.js